import React from 'react'
const client = [
  [
    [
      {
        id: 'name',
        title: 'Name',
        helperText: 'Enter the client name',
        default: '',
        validate: {
          type: 'string',
          methods: [
            ['required', 'Required'],
          ],
        },
      },{
        id: 'meta.email',
        title: 'Email',
        helperText: 'Enter the client email address',
      },{
        id: 'meta.phone',
        title: 'Phone',
        helperText: 'Enter the client phone number',
      },{
        id: 'meta.address1',
        title: 'Address 1',
        helperText: 'Enter the first line of the address',
      },{
        id: 'meta.address2',
        title: 'Address 2',
        helperText: 'Enter the second line of the address',
      },{
        id: 'meta.city',
        title: 'City',
        helperText: 'Enter the city',
      },{
        id: 'meta.county',
        title: 'County',
        helperText: 'Enter the county',
      },{
        id: 'meta.postcode',
        title: 'Postcode',
        helperText: 'Enter the postcode',
      },{
        id: 'meta.country',
        title: 'Country',
        helperText: 'Enter the country',
      },
      'Currency - defaults will be used from workspace',
      {
        id: 'meta.currency.vat',
        title: 'VAT',
        helperText: 'The percentage VAT applicable in your country',
      },
      'Markup - defaults will be used from workspace',
      {
        id: 'meta.markup.materials',
        title: 'Materials',
        helperText: 'The percentage markup to add to materials',
      },
      {
        id: 'meta.markup.labour',
        title: 'Labour',
        helperText: 'The percentage markup to add to labour',
      },
      {
        id: 'meta.markup.hire',
        title: 'Hire',
        helperText: 'The percentage markup to add to materials',
      },
      {
        id: 'meta.markup.waste',
        title: 'Waste',
        helperText: 'The percentage markup to add to waste',
      },
      {
        id: 'meta.markup.misc',
        title: 'Misc',
        helperText: 'The percentage markup to add to misc',
      },
    ],
    [
      {
        id: 'meta.notes',
        title: 'Notes',
        helperText: 'Add notes for this client',
        list: {
          mainField: 'deleteTitle',
          onAdd: (data) => {
            return Object.assign({}, data, {
              timestamp: new Date().getTime(),
              deleteTitle: 'note'
            })
          },
          schema: [{
            id: 'notes',
            title: 'Notes',
            component: 'textarea',
            rows: 5,
            helperText: 'Enter the notes',
          }],
          table: [{
            name: 'timestamp',
            title: 'Date',
            render: (row) => {
              return (
                <div>
                  { new Date(row.timestamp).toLocaleString() }
                </div>
              )
            }
          },{
            name: 'notes',
            title: 'Notes',
          }],
        },
      }
    ]
  ]
]

export default client